import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthenticationService } from '@app/core/authentication/authentication.service'; import { ActivatedRoute, Router } from '@angular/router';
import { label } from '@app/constants/labels';
import { rolesdef } from '@app/constants/role-def';
import { BaseAPIService } from '../../Services/api.base.service';
import { IBroadcastMessage } from '../../Models/IBroadcastMessage';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit {

  labels: any;
  roleCd: string;
  roles: any;
  isAlarmSubMenu: boolean;
  isMgmtSubMenu: boolean;
  isGrpSubMenu: boolean;
  isDataExprtSubMenu: boolean;
  mgmtLink: string;
  broadcastMessage: string = '';
  showMore: boolean = false;
  showBroadcastMessage: boolean = false;
  showBroadcastMessagebanner: boolean = false;
  showMoreDialog: boolean = false;
  broadcastMessagelong: string;
  isLoggedIn: any;
  items: MenuItem[];
  firstLoad: boolean 

  constructor(private route: ActivatedRoute, private readonly authenticationService: AuthenticationService, private readonly baseService: BaseAPIService, private readonly authService: AuthenticationService, public readonly router: Router) {
  }


  ngOnInit() {
    this.labels = label;
    this.isAlarmSubMenu = ['/rules', '/alarms'].includes(this.router.url) ? true : false;
    this.isMgmtSubMenu = ['/device', '/users', '/drivermanager', '/oem', '/device-metadata'].includes(this.router.url) ? true : false;
    this.isGrpSubMenu = ['/devicegroups'].includes(this.router.url) ? true : false;
    this.isDataExprtSubMenu = ['/haccpreports', '/export'].includes(this.router.url) ? true : false;
    this.firstLoad = true;
    this.authService.userLoginIn$.subscribe(data => {
      if (data) {
        this.isLoggedIn = data;
        this.roles = rolesdef;
        this.roleCd = this.authService.authenticatedRoleCd;
        if (this.roleCd === this.roles.master || this.roleCd === this.roles.enduser || this.roleCd === this.roles.cuserW) {
          this.mgmtLink = '/users';
        } else {
          this.mgmtLink = '/device';
        }
        if (this.firstLoad) {
          this.getBroadcastMessages();
          this.firstLoad = false;
        }
      }
    });
  }
  closeBroadcastmessage() {
    this.showBroadcastMessagebanner = false;
  }
  getBroadcastMessages() {
    const apiUrl = '/BroadcastMessage/GetActiveBroadcastMessage';
    this.baseService.GET(apiUrl)
      .subscribe((response: IBroadcastMessage) => {
        if (response != undefined && response != null) {
          this.showBroadcastMessagebanner = JSON.parse(localStorage.getItem("showBroadcastMessagebanner"));
          this.broadcastMessagelong = response.message;
          if (response.message.length > 390) {
            this.broadcastMessage = response.message.substring(0, 390);
            this.showMore = true
          } else {
            this.broadcastMessage = response.message;
          }
          this.showBroadcastMessagebanner = true;

        } else {
          this.showBroadcastMessagebanner = false;
        }
      });
  }
  showMoreMessage() {
    this.showMoreDialog = true;
  }
  closeShowMore() {
    this.showMoreDialog = false;
  }
  clearAllMenu(event: Event) {
    this.isMgmtSubMenu = this.isAlarmSubMenu = this.isGrpSubMenu = this.isDataExprtSubMenu = false;

  }
  DashboardNav(event: Event) {
    this.clearAllMenu(event)
  }
  AlarmNav(event: Event) {
    this.isMgmtSubMenu = this.isGrpSubMenu = this.isDataExprtSubMenu = false;
    this.isAlarmSubMenu = true;
  }
  GrpNav(event: Event) {
    this.isMgmtSubMenu = this.isAlarmSubMenu = this.isDataExprtSubMenu = false;
    this.isGrpSubMenu = true;
  }
  MgmtNav(event: Event) {
    this.isGrpSubMenu = this.isAlarmSubMenu = this.isDataExprtSubMenu = false;
    this.isMgmtSubMenu = true;
  }
  DataExpt(event: Event) {
    this.isGrpSubMenu = this.isAlarmSubMenu = this.isMgmtSubMenu = false;
    this.isDataExprtSubMenu = true;
  }

}
